export default class Customer {
  customerID = null;

  customerName = null;

  customerToken = null;

  defaultProviderID = null;

  constructor(customerID, customerName, customerToken, defaultProviderID) {
    this.customerID = customerID;
    this.customerName = customerName;
    this.customerToken = customerToken;
    this.defaultProviderID = defaultProviderID;
  }
}
